import { defineModal, Modal, Text } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { routes } from '@spa/core/router'
import type { FC } from 'react'
import { useNavigate } from 'react-router-dom'

export const suspendedSubscriptionModalDef = defineModal({
  name: 'suspendedSubscriptionModal'
})

const SuspendedSubscriptionModal: FC = () => {
  const { close, isOpen } = suspendedSubscriptionModalDef.useModal()
  const navigate = useNavigate()
  const { t } = usePlanningFormTranslation()

  const redirectSubscription = () => {
    close()
    navigate(routes.subscriptions.path)
  }

  return (
    <Modal variant='center' opened={isOpen} onClose={close}>
      <Modal.Header title={t('suspendedSubscriptionForm.title')} />
      <Modal.Content>
        <Text className='text-s'>{t('suspendedSubscriptionForm.text')}</Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.Footer.Success onClick={redirectSubscription} fillWidth>
          {t('suspendedSubscriptionForm.cta')}
        </Modal.Footer.Success>
      </Modal.Footer>
    </Modal>
  )
}

export default suspendedSubscriptionModalDef.withModalShow(
  SuspendedSubscriptionModal
)
